<template>
  <date-picker
    :placeholder="label ? label + ' (' + inputFormat + ')' : '(' + inputFormat + ')'"
    :value="fromValue(value)"
    :config="options"
    :disabled="disabled"
    :class="error ? 'is-invalid' : null"
    @dp-change="$emit('input', processEvent($event))"
    @dp-error="$emit('input', null)"/><!--:wrap="true"-->
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import DateFieldMixin from 'vue-forms/mixins/DateFieldMixin';
import DatePicker from 'vue-bootstrap-datetimepicker';

import { text2moment, isMoment, unix2moment } from 'core/utils';

export default {
  mixins: [ FormFieldMixin, DateFieldMixin ],

  components: {
    DatePicker
  },

  data() {
    return {
      options: {
        showClear: true,
        // showClose: true,
        format: this.inputFormat,
        useCurrent: false
      }
    };
  },

  methods: {
    fromValue(value) {
      if (value === undefined || value === null) {
        return value;
      }

      if (isMoment(value)) {
        return value;
      } else if (typeof value === 'number') {
        return unix2moment(value, 'YYYY-MM-DD');
      } else if (typeof value === 'string') {
        return text2moment(value, 'YYYY-MM-DD');
      } else {
        throw Error('Could not convert value ' + value + ' to moment');
      }
    },

    processEvent(evt) {
      if (evt.date === false) {
        return null;
      }

      return evt.date;
    }
  }
};
</script>
<style>
@import '~pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
</style>
